module.exports = __webpack_public_path__ + "img/Flag_of_Nicaragua.90df73ab.svg";